// src/pages/IndoorMap/RouteOverlay.jsx
import React, { useEffect } from "react"
import { useDrawRoute } from "../../utils/useDrawRoute"

const RouteOverlay = ({ RouteComponent, active, routeKey, swapped }) => {
    const { containerRef, play, stop } = useDrawRoute()

  useEffect(() => {
    if (active && RouteComponent) {
      play({ reverse: swapped })
    } else {
      stop()
    }
   }, [active, RouteComponent, routeKey, swapped, play, stop])
  if (!RouteComponent) return null

  return (
    <div ref={containerRef} className={`route-instance${swapped ? " is-swapped" : ""}`}>
      <RouteComponent className="route-inline-svg" />
    </div>
  )
}

export default RouteOverlay